import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import DetailsFacturationHeader from './detailsFacturationHeader';
import entete from 'data/entetes';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';

const columns = [
  {
    accessorKey: 'nfact',
    header: 'Num transaction',
    meta: {
      headerProps: { className: 'pe-1 white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap' },
    },
  },
  {
    accessorKey: 'codeproduit',
    header: 'code produit',
    meta: {
      headerProps: { className: 'ps-2 text-900', style: { height: '46px' } },
      cellProps: {
        className: 'white-space-nowrap pe-5 ps-2 py-2',
      },
    },
  },
  {
    accessorKey: 'produit',
    header: 'produit',
    meta: {
      headerProps: { className: 'pe-1 white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap' },
    },
  },
  {
    accessorKey: 'puht',
    header: 'PUTTC ',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-2 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'qte',
    header: 'Quantité',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-2 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'promo',
    header: 'Promo',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-2 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'tva',
    header: 'TVA',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-4 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'magasin',
    header: 'Magasin',
    meta: {
      headerProps: { className: 'text-end text-900 w-10' },
      cellProps: { className: 'ps-4 text-end w-10' },
    },
  },
];

const columnsGroup = [
  {
    accessorKey: 'codeproduit',
    header: 'code produit',
    meta: {
      headerProps: { className: 'ps-2 text-900', style: { height: '46px' } },
      cellProps: {
        className: 'white-space-nowrap pe-5 ps-2 py-2',
      },
    },
  },
  {
    accessorKey: 'produit',
    header: 'produit',
    meta: {
      headerProps: { className: 'pe-1 white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap' },
    },
  },
  {
    accessorKey: 'puht',
    header: 'PUTTC ',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-2 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'qte',
    header: 'Quantité',
    meta: {
      headerProps: { className: 'text-900 text-start pe-9' },
      cellProps: {
        className: 'white-space-nowrap pe-9 text-start',
      },
    },
  },
  {
    accessorKey: 'promo',
    header: 'Promo',
    meta: {
      headerProps: {
        className: 'text-end white-space-nowrap text-900 pe-2 text-end',
      },
      cellProps: {
        className: 'font-sans-serif fs-9 text-end',
      },
    },
  },
  {
    accessorKey: 'tva',
    header: 'TVA',
    meta: {
      headerProps: { className: 'text-900 text-start pe-9' },
      cellProps: {
        className: 'white-space-nowrap pe-9 text-start',
      },
    },
  },
];
//   {
//     accessorKey: 'codeproduit',
//     header: 'code produit',
//     meta: {
//       headerProps: { className: 'ps-2 text-900', style: { height: '46px' } },
//       cellProps: {
//         className: 'white-space-nowrap pe-5 ps-2 py-2'
//       }
//     }
//   },
//   {
//     accessorKey: 'produit',
//     header: 'produit',
//     meta: {
//       headerProps: { className: 'pe-1 white-space-nowrap text-900' },
//       cellProps: { className: 'font-sans-serif white-space-nowrap' }
//     }
//   },
//   {
//     accessorKey: 'qte',
//     header: 'Quantité',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   },
//   {
//     accessorKey: 'puht',
//     header: 'PU HTVA AVP',
//     meta: {
//       headerProps: {
//         className: 'text-end white-space-nowrap text-900 pe-2 text-end'
//       },
//       cellProps: {
//         className: 'font-sans-serif fs-9 text-end'
//       }
//     }
//   },
//   {
//     accessorKey: 'puht',
//     header: 'TT HTVA AVANT PROMO',
//     meta: {
//       headerProps: {
//         className: 'text-end white-space-nowrap text-900 pe-2 text-end'
//       },
//       cellProps: {
//         className: 'font-sans-serif fs-9 text-end'
//       }
//     }
//   },

//   {
//     accessorKey: 'promo',
//     header: 'TT HTVA APRES PROMO',
//     meta: {
//       headerProps: {
//         className: 'text-end white-space-nowrap text-900 pe-2 text-end'
//       },
//       cellProps: {
//         className: 'font-sans-serif fs-9 text-end'
//       }
//     }
//   },
//   {
//     accessorKey: 'tva',
//     header: 'TVA 7%',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   },
//   {
//     accessorKey: 'tva',
//     header: 'TVA 12%',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   },
//   {
//     accessorKey: 'tva',
//     header: 'TVA 19%',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   },
//   {
//     accessorKey: 'tva',
//     header: 'TVA 19%',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   },
//   {
//     accessorKey: 'tva',
//     header: 'TOTAL TTC',
//     meta: {
//       headerProps: { className: 'text-900 text-start pe-9' },
//       cellProps: {
//         className: 'white-space-nowrap pe-9 text-start'
//       }
//     }
//   }
// ];

const sumValues = data => {
  return data.reduce(
    (acc, obj) => ({
      mntdtfin: acc.mntdtfin + parseFloat(obj.mntdtfin || 0),
      mntdt: acc.mntdt + parseFloat(obj.mntdt || 0),
      valremise: acc.valremise + parseFloat(obj.valremise || 0),
      valtva: acc.valtva + parseFloat(obj.valtva || 0),
      tva18: acc.tva18 + parseFloat(obj.tva18 || 0),
      tva12: acc.tva12 + parseFloat(obj.tva12 || 0),
      tva6: acc.tva6 + parseFloat(obj.tva6 || 0),
    }),
    {
      mntdtfin: 0,
      mntdt: 0,
      valremise: 0,
      valtva: 0,
      tva18: 0,
      tva12: 0,
      tva6: 0,
    }
  );
};

const DetailsFacturation = ({
  filteredFactures = [],
  typeLignes,
  selectedRows = [],
  changedSelection,
}) => {
  const [data, setData] = useState([]);
  const [colonnes, setColonnes] = useState(columns);
  const [Timbre, setTimbre] = useState(1.0);
  const [isProcessing, setIsProcessing] = useState(false);
  const navigate = useNavigate();
  const userID = useSelector(state => state.auth.user.id);
  useEffect(() => {
    if (typeLignes === 'Groupées') {
      setColonnes(columnsGroup);
    } else {
      setColonnes(columns);
    }
  }, [typeLignes]);

  useEffect(() => {
    setData(filteredFactures);
  }, [filteredFactures]);

  const table = useAdvanceTable({
    columns: colonnes,
    data,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 15,
    selectionColumnWidth: 50,
  });

  useEffect(() => {
    setData([]);
  }, [changedSelection]);

  const creerFacture = async () => {
    setIsProcessing(true);
    if (selectedRows.length === 0) {
      toast.error('Veuillez sélectionner au moins une ligne');
      return;
    }
    const entetes = selectedRows.map(row => row.original);
    const total = sumValues(entetes);
    const nfacts = entetes.map(row => row.nfact);
    await entete.creerFacture({
      entete: {
        ...total,
        nfacts: nfacts,
        magasin: entetes[0].magasin,
        codeclient: entetes[0].codeclient,
        client: entetes[0].client,
        timbre: Timbre,
        vendeur: userID,
        numfacture: entetes[0].numfacture,
      },
      lignes: data,
    });
    setIsProcessing(false);
    navigate('/dashboard/factures');
  };

  return (
    <>
      <Row className="gx-1">
        <Col>
          <AdvanceTableProvider {...table}>
            <Card>
              <Card.Header className="px-0">
                <DetailsFacturationHeader
                  creerFacture={creerFacture}
                  Timbre={Timbre}
                  setTimbre={setTimbre}
                  isProcessing={isProcessing}
                  nombreArticles={data.length}
                  typeTransaction={
                    selectedRows && selectedRows.length > 0
                      ? selectedRows[0].original.numfacture === '5'
                        ? 'Retour'
                        : 'Vente'
                      : ''
                  }
                />
              </Card.Header>
              <Card.Body className="p-0">
                <AdvanceTable
                  headerClassName="bg-body-tertiary align-middle"
                  rowClassName="btn-reveal-trigger align-middle"
                  tableProps={{
                    size: 'sm',
                    className: 'fs-10 mb-0 overflow-hidden',
                  }}
                />
              </Card.Body>
              <Card.Footer>
                <AdvanceTableFooter rowInfo navButtons rowsPerPageSelection />
              </Card.Footer>
            </Card>
          </AdvanceTableProvider>
        </Col>
      </Row>
    </>
  );
};

DetailsFacturation.propTypes = {
  filteredFactures: PropTypes.array,
  typeLignes: PropTypes.string,
  selectedRows: PropTypes.array,
};

export default DetailsFacturation;
